// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gp8O","select":"styles_select__1Bczu"};